<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteSaleConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          .form__label
            label.label(style='padding-left: 5px; font-size: .85rem; color: rgba(0,0,0,.7);') Mapa
          vm-select(v-model='map_id')
            vm-select-item(:key='index' :value='item.id' :text='item.title' @change="getLots()" v-for='item,index in maps')
        b-form-group
          .form__label
            label.label(style='padding-left: 5px; font-size: .85rem; color: rgba(0,0,0,.7);') Lote
          vm-select(v-model='newRecord.lot_id')
            vm-select-item(:key='index' :value='item.id' :text='item.title' v-for='item,index in lots')
        //- slot {{map_id}}
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ModalSales',
  data: () => ({
    map_id: 1,
    selected: []
  }),
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    newRecord: {
      lot_id: {
        required
      }
    }
  },
  async created () {
    await this.getMaps()
    await this.getLots()
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'maps',
      'lots',
      'salesCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('sales.add') : this.$t('sales.edit')
    }
  },
  methods: {
    ...mapActions([
      'addSale',
      'editSale',
      'deleteSale',
      'loadMaps',
      'loadLots',
      'changeLot',
      'setModalVisible',
      'loadCatalog'
    ]),
    getLots () {
      this.loadLots({ map_id: this.map_id })
    },
    getMaps (page) {
      this.loadMaps()
    },
    saveRecord () {
      this.changeLot(this.newRecord)
    },
    async deleteSaleConfirm (sale) {
      let t = this
      this.auxDeleteSale = () => {
        t.deleteSale(sale)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(sale.id) }),
        accept: this.auxDeleteSale
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  },
  watch: {
    map_id (id) {
      this.getLots()
    }
  }
}
</script>
